import type { SerializedCompStructure } from '@wix/document-services-types';
import { transformCompStructure } from './siteGeneratorUtils';
import {
  WIX_BLOG,
  WIX_STORES,
  WIX_NEW_STORES,
  WIX_SITE_SEARCH,
  MEMBERS_AREA,
  WIX_BOOKINGS,
  WIX_EVENTS,
  WIX_RESTAURANTS_ORDERS_NEW,
} from '@wix/app-definition-ids';
import { filterHeaderOrFooterWidgets } from './headerAndFooterUtils';

export const getWidgetToRootAppMap = (
  isUsingSgOrigin: boolean,
): Record<string, string[]> => ({
  [WIX_SITE_SEARCH]: [WIX_BLOG],
  [WIX_STORES]: [WIX_NEW_STORES, WIX_RESTAURANTS_ORDERS_NEW],
  [MEMBERS_AREA]: isUsingSgOrigin
    ? [
        WIX_NEW_STORES,
        WIX_BLOG,
        WIX_BOOKINGS,
        WIX_EVENTS,
        WIX_RESTAURANTS_ORDERS_NEW,
      ]
    : [WIX_RESTAURANTS_ORDERS_NEW],
});

export const adjustHeaderWidgetsByRootApp = (
  headerStructure: SerializedCompStructure,
  rootApps: string[],
  isUsingSgOrigin: boolean,
): SerializedCompStructure => {
  const widgetToRootAppMap = getWidgetToRootAppMap(isUsingSgOrigin);
  const shouldKeepWidgetByRootApp = (appDefId: string): boolean => {
    const widgetRootApps = widgetToRootAppMap[appDefId];
    if (widgetRootApps?.length) {
      return widgetRootApps.some((appDefId) => rootApps.includes(appDefId));
    }
    return true;
  };
  const mutator = (comp: SerializedCompStructure) => {
    return filterHeaderOrFooterWidgets(shouldKeepWidgetByRootApp, comp);
  };
  return transformCompStructure(headerStructure, mutator);
};
